const dataSelectors = {
  body: 'body',
  productsFeaturedCollection: '.featured-collection__inner-container',
  productsGrid: '#main-collection-product-grid',
  productsCartRecommendation: '.cart-product-recommendations',
  productRecommendations: '.product-recommendations',
  productItem: '[data-js-product-item]',
  productItemData: '[product-item-data]',
  productPageItem: '[product-page-item-data]',
  productAddToCartButton: '[data-js-product-add-to-cart]',
  productPage: 'product-page',
  cartPageItem: '[data-js-cart-item]',
  cartPageItemData: '[cart-page-item-data]',
  cartPageProductQuantityMinus: '[data-js-cart-item-qty-minus]',
  cartPageProductRemove: '[data-js-cart-item-remove]',
  cartPageProductsForm: '#AjaxCartForm',
  cartPageListName: '[data-js-cart-page-list-name]',
  productQuantityInput: '.product-quantity__selector',
  searchRecommendationContainer: '.search-results-container',
  searchRecommendationItem: '.search-item',
  searchRecommendationItemTitle: '.cart-item__title',
};

window.persistedCartData = {
  /**
   * Save custom informations about products in cart
   *
   * @param {Object} newProduct product object added to cart
   */
  saveNewProduct(newProduct) {
    const alreadyAddedProducts = window.persistedCartData.getSession();
    const prodExist = alreadyAddedProducts.find((p) => Number(p.product_id) === Number(newProduct.item_id));
    if (!prodExist) {
      alreadyAddedProducts.push(newProduct);
    }
    localStorage.setItem('addedToCartProducts', JSON.stringify(alreadyAddedProducts));
  },

  /**
   * Remove custom informations about product in cart
   *
   * @param {Object} product product object removed from cart
   */
  removeProduct(product) {
    const alreadyAddedProducts = window.persistedCartData.getSession();
    localStorage.setItem('addedToCartProducts', JSON.stringify(alreadyAddedProducts.filter((p) => Number(p.product_id) !== Number(product.item_id))));
  },

  /**
   * Retrieve persisted data if exist
   */
  getSession() {
    const persistedData = localStorage.getItem('addedToCartProducts');
    return persistedData ? JSON.parse(persistedData) : [];
  },

  /**
   * Clear removed products
   */
  clear() {
    fetch('/cart.js').then((res) => res.json()).then((data) => {
      const { items } = data;
      const persistedData = window.persistedCartData.getSession();

      if (!persistedData) return;
      const idsInCart = items.map((obj) => obj.product_id);
      const filteredPersisted = persistedData.filter((obj) => idsInCart.includes(Number(obj.item_id)));
      localStorage.setItem('addedToCartProducts', JSON.stringify(filteredPersisted));
    });
  },
};

const body = document.querySelector(dataSelectors.body);
let template = '';
if (body.classList.contains('template-index')) template = 'Home page - ';
if (body.classList.contains('template-product')) template = 'Product page - ';
if (body.classList.contains('template-collection')) template = 'Category page - ';
if (body.classList.contains('template-search')) template = 'Search page';
if (body.classList.contains('template-cart')) template = 'Cart page - ';

/**
 * Wait for elements that will be added to the DOM
 *
 * @param {HTMLCollection} selector CSS selector
 * @param {Function} callback callback function
 */
function waitForAppearanceInDOM(selector, callback) {
  let counter = 0;
  const interval = setInterval(() => {
    const elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
      callback(elements);
      clearInterval(interval);
    }
    if (counter === 20) clearInterval(interval);
    counter += 1;
  }, 500);
}

/**
 * Pushing to dataLayer information about clicked product from list
 *
 * @param {HTMLCollection} list list that contains multiple products
 */
function addSelectItemListener(list) {
  list.addEventListener('click', (e) => {
    const data = JSON.parse(e.target?.closest('a')?.closest(dataSelectors.productItem)?.querySelector(dataSelectors.productItemData)?.innerHTML || false);
    if (!data) return;
    data.page_type = template.replace(' -', '') || body.dataset.pageType;
    const item = { ...data };
    delete item.value;
    delete item.currency;
    item.item_list_name = template + item.item_list_name;
    sessionStorage.setItem('lastSelectedProduct', JSON.stringify(data));
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        items: [item],
      },
    });
  });
}

/**
 * function to send event about clicked product in search result recommendations (dropdown)
 *
 * @param {event} ev click event
 */
const searchRecommendationClick = (ev) => {
  let el = null;
  if (ev.target.classList.contains(dataSelectors.searchRecommendationItem.replace('.', ''))) {
    el = ev.target;
  } else {
    el = ev.target.closest(dataSelectors.searchRecommendationItem);
  }
  if (!el) return;
  const data = JSON.parse(el.querySelector(dataSelectors.productItemData)?.innerHTML);
  if (!data) return;
  data.page_type = template.replace(' -', '') || body.dataset.pageType;
  const item = { ...data };
  delete item.value;
  delete item.currency;
  data.item_list_name = 'search dropdown results';
  item.item_list_name = `${template} search dropdown results`;
  sessionStorage.setItem('lastSelectedProduct', JSON.stringify(data));
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      item_list_id: item.item_list_id,
      item_list_name: item.item_list_name,
      items: [item],
    },
  });
};

/**
 * Pushing to dataLayer information about list of products visible on page
 *
 * @param {HTMLCollection} list list that contains multiple products
 */
function pushViewProductsList(list) {
  const products = list.querySelectorAll(dataSelectors.productItem);
  if (products.length === 0) return;
  const items = [];
  products.forEach((product) => {
    const data = JSON.parse(product.querySelector(dataSelectors.productItemData)?.innerHTML);
    if (!data) return;
    const item = { ...data };
    delete item.value;
    delete item.currency;
    item.item_list_name = template + item.item_list_name;
    items.push(item);
  });
  const limit = 30;
  for (let i = 0; i < items.length; i += limit) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: items[0].item_list_id,
        item_list_name: items[0].item_list_name,
        items: items.slice(i, i + limit),
      },
    });
  }
}

/**
 * Pushing to dataLayer information about product added to cart from list
 *
 * @param {HTMLCollection} list list that contains multiple products
 */
function addItemToCartListener(list) {
  list.addEventListener('click', (e) => {
    const data = JSON.parse(
      e.target?.closest(dataSelectors.productAddToCartButton)?.closest(dataSelectors.productItem)?.querySelector(dataSelectors.productItemData)?.innerHTML || false
    );
    if (!data) return;
    const item = { ...data };
    delete item.value;
    delete item.currency;
    delete item.promotion_name;
    delete item.promotion_id;
    item.item_list_name = (template + item.item_list_name).replace('- -', '-');
    item.addition_type = 'listpage';

    window.persistedCartData?.saveNewProduct(item);

    // 04.07.23 Event hide as client want test application for that - DO NOT DELETE
    // window.dataLayer.push({ ecommerce: null });
    // window.dataLayer.push({
    //   event: 'add_to_cart',
    //   ecommerce: {
    //     currency: data.currency,
    //     value: data.value,
    //     items: [item],
    //   },
    // });
  });
}

/**
 * Pushing to dataLayer information about product on product page
 */
function pushViewProductPageDetail() {
  const data = JSON.parse(document.querySelector(dataSelectors.productPageItem)?.innerHTML);
  if (!data) return;
  const item = { ...data };
  delete item.value;
  delete item.currency;
  const lastSelectedProduct = sessionStorage.getItem('lastSelectedProduct');
  if (lastSelectedProduct) {
    const lastSelectedProductData = JSON.parse(lastSelectedProduct);
    item.item_list_id = lastSelectedProductData.item_list_id;
    const listName = lastSelectedProductData.item_list_name ? `- ${lastSelectedProductData.item_list_name}` : '';
    item.item_list_name = `${lastSelectedProductData.page_type} ${listName}`;
  }
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: data.currency,
      value: data.value,
      items: [item],
    },
  });
}

/**
 * Pushing to dataLayer information about main product added to cart on product page
 */
function addMainProductToCart() {
  const buttons = document.querySelectorAll(`${dataSelectors.productPage} ${dataSelectors.productAddToCartButton}`);
  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const data = JSON.parse(
        e.target?.closest(dataSelectors.productAddToCartButton)?.closest(dataSelectors.productPage)?.querySelector(dataSelectors.productPageItem)?.innerHTML || false
      );
      if (!data) return;

      const lastSelectedProduct = sessionStorage.getItem('lastSelectedProduct');

      const item = { ...data };
      delete item.value;
      delete item.currency;
      if (lastSelectedProduct) {
        const lastSelectedProductData = JSON.parse(lastSelectedProduct);
        item.item_list_id = lastSelectedProductData.item_list_id;
        const listName = lastSelectedProductData.item_list_name ? `- ${lastSelectedProductData.item_list_name}` : '';
        item.item_list_name = (`${lastSelectedProductData.page_type} - ${listName}`).replace('- -', '-');
      }
      item.addition_type = 'product page';
      item.quantity = document.querySelector(dataSelectors.productQuantityInput)?.value;

      window.persistedCartData?.saveNewProduct(item);

      // 04.07.23 Event hide as client want test application for that - DO NOT DELETE
      // window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'add_to_cart',
      //   ecommerce: {
      //     currency: data.currency,
      //     value: data.value,
      //     items: [item],
      //   },
      // });
    });
  });
}

/**
 * Pushing to dataLayer information about products in cart visible on cart page
 */
function pushViewCartPage() {
  const products = document.querySelectorAll(dataSelectors.cartPageItem);
  if (products.length === 0) return;
  const items = [];
  let currency = '';
  let cartValue = '';
  const persistedData = window.persistedCartData.getSession();
  products.forEach((product) => {
    const data = JSON.parse(product.querySelector(dataSelectors.cartPageItemData)?.innerHTML);
    if (!data) return;
    const item = { ...data };
    currency = item.currency;
    cartValue = item.cart_value;
    delete item.currency;
    delete item.cart_value;

    const persistedValues = persistedData.find((p) => Number(p.item_id) === Number(item.item_id));
    item.item_list_name = persistedValues ? persistedValues.item_list_name : '';
    item.item_list_id = persistedValues ? persistedValues.item_list_id : '';

    items.push(item);
  });
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_cart',
    ecommerce: {
      currency,
      value: cartValue,
      items,
    },
  });
}

/**
 * Pushing to dataLayer information about removed products from cart on cart page
 */
function pushRemoveFromCartPage() {
  document.querySelector(dataSelectors.cartPageProductsForm).addEventListener('click', (e) => {
    const productRemove = e.target.closest(dataSelectors.cartPageProductRemove);
    const quantityMinus = e.target.closest(dataSelectors.cartPageProductQuantityMinus);
    if (quantityMinus || productRemove) {
      const data = JSON.parse(e.target.closest(dataSelectors.cartPageItem)?.querySelector(dataSelectors.cartPageItemData)?.innerHTML || false);
      if (!data) return;
      const item = { ...data };
      delete item.currency;
      delete item.cart_value;

      const persistedData = window.persistedCartData.getSession();
      const persistedValues = persistedData.find((p) => Number(p.item_id) === Number(item.item_id));

      item.item_list_name = persistedValues ? persistedValues.item_list_name : '';
      item.item_list_id = persistedValues ? persistedValues.item_list_id : '';
      const removedQuanity = quantityMinus ? 1 : item.quantity;
      item.quantity = removedQuanity;
      const value = removedQuanity * (item.price - item.discount);
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          currency: data.currency,
          value,
          items: [item],
        },
      });
    }
  });
}

/**
 * Add common functionality for list of products
 *
 * @param {HTMLCollection} list list that contains multiple products
 */
function handleList(list) {
  addSelectItemListener(list);
  addItemToCartListener(list);
  pushViewProductsList(list);
}

/**
 * Wait for asynchronous loaded products
 *
 * @param {HTMLElement} section CSS selector
 */
function waitForAsyncProducts(section) {
  let counter = 0;
  const interval = setInterval(() => {
    const products = section.querySelectorAll(dataSelectors.productItem);
    if (products.length > 0) {
      handleList(section);
      clearInterval(interval);
    }
    if (counter === 20) clearInterval(interval);
    counter += 1;
  }, 500);
}

/**
 * Global instance of sections observer
 */
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const products = entry.target.querySelectorAll(dataSelectors.productItem);
        if (products.length) {
          handleList(entry.target);
        } else {
          waitForAsyncProducts(entry.target);
        }
        observer.unobserve(entry.target);
      }
    });
  },
  {
    root: document,
    threshold: 0.5,
  },
);

/**
 * Determine wchich lists should be observed for intersect in viewport
 *
 * @param {HTMLCollection} lists lists on page what contains multiple lists of products
 * @param {boolean} observeIntersect should wait for apperance in viewport
 */
function handleProductsLists(lists, observeIntersect = true) {
  lists.forEach((list) => {
    if (!observeIntersect) {
      handleList(list);
      return;
    }
    observer.observe(list);
  });
}

/**
 * Initialize observers
 */
function init() {
  const searchResults = document.querySelectorAll(dataSelectors.searchRecommendationContainer);
  handleProductsLists(document.querySelectorAll(dataSelectors.productsFeaturedCollection));
  handleProductsLists(document.querySelectorAll(dataSelectors.productsGrid), false);
  if (body.classList.contains('template-cart')) {
    waitForAppearanceInDOM(dataSelectors.productsCartRecommendation, handleProductsLists);
    pushViewCartPage();
    pushRemoveFromCartPage();
  }
  if (body.classList.contains('template-product')) {
    // 04.07.23 - Event hide as client want to test application for that - FOR NOW DO NOT DELETE
    // pushViewProductPageDetail();
    addMainProductToCart();
  }
  if (searchResults) {
    searchResults.forEach((c) => {
      c.addEventListener('click', (ev) => {
        searchRecommendationClick(ev);
      });
    });
  }
  window.persistedCartData.clear();
}

window.addEventListener('DOMContentLoaded', () => init());
